import { render, staticRenderFns } from "./risk-level-container.vue?vue&type=template&id=2ff59013"
import script from "./risk-level-container.vue?vue&type=script&lang=ts"
export * from "./risk-level-container.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports